module.exports = __webpack_public_path__ + "img/gkn-aero.df8499f6.jpg";